import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=fadad670&scoped=true&"
import script from "./TheSidebar.vue?vue&type=script&lang=ts&"
export * from "./TheSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=fadad670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadad670",
  null
  
)

export default component.exports